import React, { useEffect, useRef } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import './ReadOnlyBetslip.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from 'src/configs/store';
import Header from './Header/Header';
import Numbers from './Numbers/Numbers';
import Stakes from './Stakes/Stakes';
import Combinations from './Combinations/Combinations';
import StakeSelection from './StakeSelection/StakeSelection';
import Permutations from '../Permutaions/Permutations';
import { format } from 'date-fns';
import HeaderMax from './HeaderMax/HeaderMax';
import NumbersMax from './NumbersMax/NumbersMax';

function ReadOnlyBetslip() {
  const { t } = useTranslation();
  const selectedSlip =useSelector((state: RootState) => state.betslip.slip);
  const stakes = useSelector((state: RootState) => state.betslip.stakes);
  const showReadBetPermutation = useSelector((state: RootState) => state.betslip.showReadBetPermutation);
  const readBetPermutations = useSelector((state: RootState) => state.betslip.readBetPermutations);
  const newBetIndex = useSelector((state: RootState) => state.betslip.newBetIndex);
  const showPermutations = useSelector((state: RootState) => state.betslip.readShowPermutations);
  const stakingRules = useSelector((state: RootState) => state.content.stakingRules);
  const defaultSlip = 'wide';
  const singleSlip = useSelector((state: RootState) => state.betslip.singleSlip);
  const accaSlip = useSelector((state: RootState) => state.betslip.accaSlip);
  const systemSlip = useSelector((state: RootState) => state.betslip.systemSlip);
  const bets = useSelector((state: RootState) => state.betslip.bets);

  let slip = singleSlip;
  if (selectedSlip === 1) slip = accaSlip;
  else if (selectedSlip === 2) slip = systemSlip;

  let _slip = 'single';
  if (selectedSlip === 1) _slip = 'acca';
  else if (selectedSlip === 2) _slip = 'system';

  const initialValue = 0;
  const numberOfBets = bets.reduce(
    (accumulator, bet) => accumulator + (bet.permutationsCount ? bet.permutationsCount : 1),
    initialValue
  );

  const ref = useRef(null);

  useEffect(() => {
    if (ref && ref.current){
      ref.current.scrollIntoView({
        behavior:'smooth',
        block: 'end',
        inline:'end'
      });
    }
  }, [ref, newBetIndex]);

  const checkSelectedNumbers = () => {
    const bet = _.find(bets, (bet) => {
      let isCorrect = false;

      if (+readBetPermutations.eventCode === +bet['eventCode'] && +readBetPermutations.marketCode === +bet['marketCode']){
        isCorrect = true;
      }

      if (isCorrect){
        const numbers = [];
        const bonus = [];

        for (const number of bet['selectedNumbers']){
          if (number.type === 'star') {
            bonus.push(number.number);
          } else {
            numbers.push(number.number);
          }
        }

        if (readBetPermutations.prediction['rankedNumbers'].length >=2){

          if (numbers.every((n) => readBetPermutations.prediction['rankedNumbers'][0]['numbers'].includes(n)) &&
            bonus.every((n) => readBetPermutations.prediction['rankedNumbers'][1]['bonus'].includes(n))){
            return bet;
          }
        }

        if (numbers.every((n) => readBetPermutations.prediction['anyNumbers'].includes(n))){
          return bet;
        }
        if (bonus.every((n) => readBetPermutations.prediction['rankedNumbers'][0]['bonus'].includes(n))){
          return bet;
        }
      }
      return false;
    }
    );

    return { numbers: bet['selectedNumbers'] || null, sameDrum: bet['sameBallSet'] || false, index: _.indexOf(bets, bet) };
  };

  const checkRacingValues = (bet) => {

    if (((!bet.prediction || bet.prediction?.numbersToPredictCount === 1) && (bet.oddsType !== 'tote' && bet.oddsType))){
      return !_.isEmpty(bet.jsonLabel) ? `${ bet.jsonLabel.id }. ${ bet.jsonLabel.competitor }` : bet.prediction.anyNumbers.join(',');
    }
    return bet.jsonLabel;
  };

  const checkMarketName = (bet) => {

    if (bet.type === 'racing'){
      return `${ t('betslip.race') } ${ bet.raceNo }`;
    } else if (bet.type === 'sport'){
      return bet.eventName;
    }
    return `${ format(bet.datetime, 'HH:mm') } Draw`;
  };

  const checkValidMessage = (betStake) => {
    const rule = stakingRules.sports[_slip];

    if (rule && rule.minimum > betStake) {
      return `${ t('betslip.stakeMinimumError') } ${ rule.minimum }`;
    } else if (rule && rule.maximum < betStake) {
      return `${ t('betslip.stakeMaximumError') } ${ rule.maximum }`;
    } else {
      return '';
    }
  };

  return (
    <div className="read-betslip">
      <div className="read-betslip__container">
        <div className="read-betslip__header">
          <span className="read-betslip__title">{ t('secondScreen.betslip') }</span>
          <span className="read-betslip__summary">
            { `${ bets.length } ${ t('secondScreen.lines') }, ${ numberOfBets } ${ t('secondScreen.bets') }` }
          </span>
        </div>
        {
          !showReadBetPermutation &&
            <div className="read-betslip__wrapper-tabs">
              <div className={
                classNames({
                  'read-betslip__tab': true,
                  'read-betslip__tab--selected': selectedSlip === 0
                })
              }
              >{ t('betslip.singleTab') }
              </div>
              <div className={
                classNames({
                  'read-betslip__tab': true,
                  'read-betslip__tab--selected': selectedSlip === 1
                })
              }
              >{ t('betslip.accumulatorTab') }
              </div>
              <div className={
                classNames({
                  'read-betslip__tab': true,
                  'read-betslip__tab--selected': selectedSlip === 2
                })
              }
              >{ t('betslip.systemTab') }
              </div>
            </div>
        }
        {
          !showPermutations && !showReadBetPermutation &&
          _.map(bets, (bet, index) => {
            const stake= _.find(stakes, s => s['lines'].length === 1 && s['lines'][0] === (index + 1));
            let refProps = {};

            const isSuspended = +bet.marketStatusNumber === 3 || +bet.outcomeStatusNumber === 3;
            if (index === newBetIndex){
              refProps = { ref: ref };
            }
            const suspendedName = +bet.marketStatusNumber === 3 ? bet.marketStatusName : bet.outcomeStatusName;
            const validMessage = checkValidMessage(stake);

            const showCombinableWarning =
            selectedSlip !== 0 &&
            bet.combinationExclusions &&
            bet.combinationExclusions.length > 0;

            return (
              <div
                className={
                  classNames({
                    'read-betslip__betline': true,
                    'read-betslip__betline--suspended': isSuspended
                  })
                }
                key={ index }
                { ...refProps }
              >
                {
                  isSuspended && <div className="read-betslip__suspended" />
                }
                {
                  ((index=== 0 || bets[+index].tournamentName !== bets[+index -1].tournamentName) &&
                  (index=== 0 || bets[+index] !== bet[+index-1]?.datetime)) && defaultSlip !== 'wide' &&
                 <Header
                   country={ bet.country }
                   teamMarkets={ checkMarketName(bet) }
                   showHeader={ index === 0 || (bets[index].eventCode !== bets[index-1].eventCode) }
                   venue={ bet.venue || null }
                   date={ bet.datetime }
                   touramentName={ bet.type === 'sport' ? bet.tournamentName : bet.eventName }
                   type={ bet.type }
                   sport={ bet.sport }
                 />
                }
                {
                  ((index=== 0 || bets[+index].tournamentName !== bets[+index -1].tournamentName) &&
                  (index=== 0 || bets[+index] !== bet[+index-1]?.datetime)) && defaultSlip === 'wide' &&
                 <HeaderMax
                   country={ bet.country }
                   teamMarkets={ checkMarketName(bet) }
                   showHeader={ index === 0 || (bets[index].eventCode !== bets[index-1].eventCode) }
                   venue={ bet.venue || null }
                   date={ bet.datetime }
                   touramentName={ bet.type === 'sport' ? bet.tournamentName : bet.eventName }
                   type={ bet.type }
                   sport={ bet.sport }
                 />
                }
                {
                  defaultSlip !== 'wide' && <Numbers
                    selectedNumbers={ bet.selectedNumbers }
                    marketName={ bet.marketName }
                    sameDrum= { bet.sameBallSet }
                    odds={ bet.odds }
                    isRacing={ bet.type === 'racing' }
                    betIndex={ index +1 }
                    permutationsCount={ bet.permutationsCount }
                    addPadding={ slip.stakeSelection !== 'differentStake' }
                    jsonLabel= { checkRacingValues(bet) }
                    type={ bet.typeCode === 800 ? 'sport' : bet.type }
                    outcome={ bet.outcome }
                    numbersToPredictCount={ bet.type === 'racing' && bet.prediction ? bet.prediction?.numbersToPredictCount : 1 }
                  />
                }
                <NumbersMax
                  selectedNumbers={ bet.selectedNumbers }
                  marketName={ bet.marketName }
                  sameDrum= { bet.sameBallSet }
                  odds={ bet.odds }
                  isRacing={ bet.type === 'racing' }
                  betIndex={ index +1 }
                  permutationsCount={ bet.permutationsCount }
                  addPadding={ slip.stakeSelection !== 'differentStake' }
                  jsonLabel= { checkRacingValues(bet) }
                  type={ bet.typeCode === 800 ? 'sport' : bet.type }
                  outcome={ bet.outcome }
                  numbersToPredictCount={ bet.type === 'racing' && bet.prediction ? bet.prediction?.numbersToPredictCount : 1 }
                  stake={ stake }
                />
                {
                  isSuspended &&<div className="bet-stakes__suspended">
                    <span>{ t('betslip.marketSuspended') }</span>
                    <span>{ suspendedName }</span>
                  </div>
                }
                {
                  validMessage !== '' && singleSlip.stakeSelection === 'differentStake' &&(
                    <div className="numberbet-stakes__minimum-warning"><span>
                      { validMessage }
                    </span>
                    </div>
                  )
                }
                {
                  showCombinableWarning && (
                    <div className="numberbet-stakes__combinable">{ t('betslip.notCombinable') } { bet.combinationExclusions.toString() }</div>
                  )
                }
                {
                  (slip.stakeSelection === 'differentStake' && defaultSlip !== 'wide') &&
                  <Stakes permutationsCount={ bet.permutationsCount } stake={ stake } />
                }
              </div>
            );
          })
        }
        {
          showReadBetPermutation && readBetPermutations.eventCode && (
            <>
              <Permutations
                title={
                  t('numbers.combinationsOnLine', { line: readBetPermutations.productType !== 'horses' ?
                    checkSelectedNumbers().index +1 : _.findIndex(bets, { eventCode: readBetPermutations.eventCode,
                      marketCode: +readBetPermutations.marketCode })+1,
                  combos: readBetPermutations.prediction?.permutationsCount  })
                }
                stake={ readBetPermutations.prediction['singleStake'] }
                profit={ readBetPermutations.prediction.minimumReturn }
                permutations={ readBetPermutations.prediction?.permutations2 }
                numbers={ readBetPermutations.productType !== 'horses' ? checkSelectedNumbers().numbers : null }
                sameDrum= { readBetPermutations.productType !== 'horses' ?  checkSelectedNumbers().sameDrum : false }
                isHorses= { readBetPermutations.productType === 'horses' }
              />
            </>
          )
        }
      </div>
      {
        !showReadBetPermutation &&
        <div className="read-betslip__footer">
          <Combinations totalCombinations={ _.filter(stakes, line => line.stake > 0).length } />
          <StakeSelection />
        </div>
      }
    </div>
  );
}

export default ReadOnlyBetslip;
